import { createApp } from 'vue';
import { createHead } from '@vueuse/head';
import App from './App.vue';
// import './registerServiceWorker';
import router from './router';
import store from './store';
import plugins from '@/plugins';

createApp(App).use(store).use(router).use(createHead()).use(plugins).mount('#app');
